import { NgModule } from '@angular/core';
import { ParallaxConfig, ParallaxDirective } from './parallax/parallax.directive';

@NgModule({
    declarations: [ ParallaxDirective ],
    exports: [ ParallaxDirective ],
})
export class ParallaxModule {}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/parallax.module.ts